export type TaskPriority = 'low' | 'medium' | 'high';

export type TaskStatus = 'open' | 'completed' | 'overdue';

export type TaskSourceType = 'message' | 'manual';

export interface TaskSourceRef {
  message_id: string;
}

export const PRIORITY_LABEL: Record<TaskPriority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
};

export type CreateTaskPayloadBase = {
  title: string;
  description: string | null;
  priority: TaskPriority | null;
  assignee_id: string;
  /** RFC3339 UTC date-time, must be in the future, or null. */
  due_at: string | null;
  reminder_enabled: boolean;
};

export type CreateTaskPayloadWithSource = {
  source_type: 'message';
  source_ref: TaskSourceRef;
};

export type CreateTaskPayloadWithNoSource = {
  source_type: 'manual';
};

/** Request body for `POST /v2/tasks`. */
export type CreateTaskPayload = CreateTaskPayloadBase &
  (CreateTaskPayloadWithSource | CreateTaskPayloadWithNoSource);

/** A task as returned by task-svc. */
export interface Task {
  id: string;
  title: string;
  description: string | null;
  priority: TaskPriority | null;
  assignee_id: string;
  due_at: string | null;
  reminder_enabled: boolean;
  status: TaskStatus;
  source_type: TaskSourceType;
  source_ref: TaskSourceRef;
  creator_id: string;
  created_at: string;
  updated_at: string;
  completed_at?: string | null;
}

type AtLeastOne<T> = { [K in keyof T]: Pick<T, K> }[keyof T] & Partial<T>;

interface UpdateTaskFields {
  title?: string;
  description?: string | null;
  priority?: TaskPriority | null;
  /** RFC3339 UTC date-time, or null. */
  due_at?: string | null;
  reminder_enabled?: boolean;
}

/** Request body for `PATCH /v2/task-management/tasks/:task_id`. At least one field required. */
export type UpdateTaskPayload = AtLeastOne<UpdateTaskFields>;

/** task-svc error envelope: `{ error: { code, message, field? } }`. */
export interface TaskSvcErrorBody {
  code: string;
  message: string;
  field?: string;
}

export type CounterPartyType = 'p2p' | 'group' | 'list';

/** Request body for `POST /v2/task-management/tasks/messages`. */
export interface ConversationTasksRequest {
  counter_party_id: string;
  counter_party_type: CounterPartyType;
  /** Optional narrowing (max 200). Absent or empty means the whole conversation. */
  message_ids?: string[];
  limit?: number;
  cursor?: string;
}

export interface MessageTaskGroup {
  message_id: string;
  tasks: Task[];
}

export interface ConversationTasksResponse {
  messages: MessageTaskGroup[];
  paging: { next_cursor: string | null };
}
